import { render, staticRenderFns } from "./AtendimentoHipertensao.vue?vue&type=template&id=2bb118f8"
import script from "./AtendimentoHipertensao.vue?vue&type=script&lang=js"
export * from "./AtendimentoHipertensao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports